export enum AuthStatus {
  FirstLoad = 'FIRST_LOAD',
  Busy = 'BUSY',
  Authenticated = 'AUTHENTICATED',
  NotAuthenticated = 'NOT_AUTHENTICATED',
  Error = 'ERROR'
}
